import React from "react";
import { Link } from "react-router-dom";
import BookListTable from "./BookListTable";
import SearchBar from "./SearchBar";
import { Grid, Container, Message } from "semantic-ui-react";
import Button from "../../../common/components/Button/Button";

const BookList = props => {
  return (
    <Container
      style={{ padding: "6em 0em", minHeight: "90vh", overflowX: "hidden" }}
    >
      {/* 도서 신청 직후 진입 시 접수 안내 */}
      {props.batchSubmitted ? (
        <Message positive onDismiss={props.onDismissBatchSubmitted}>
          <p>도서 신청이 접수되었습니다.</p>
        </Message>
      ) : null}
      <Grid divided="vertically" verticalAlign="middle" centered>
        <Grid.Row centered columns={2}>
          <Grid.Column floated={"left"}>
            <SearchBar onSubmit={props.onSubmit} />
          </Grid.Column>
          <Grid.Column floated={"right"} textAlign={"right"}>
            {/* 단권 신청(/bookRequest)은 다중권 화면이 동일 기능을 모두 커버하게 되어 진입 버튼 제거. 라우트는 /bookMultiRequest 로 redirect. */}
            <Link to="/bookMultiRequest">
              <Button name="도서 신청" color={"green"} style={{ minWidth: 110 }} />
            </Link>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column style={{ maxWidth: 2800 }}>
            <BookListTable
              books={props.books}
              onTableRowClick={props.onTableRowClick}
              Loading={props.Loading}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default BookList;
